import React from "react";

import PictureThumbnail from "./PictureThumbnail";
import type { Picture } from "types/PictureCollection";

interface PictureCollectionProps {
  pictures: Picture[];
  selectedPictures: Picture[];
  onSelect: (pictures: Picture[]) => void;
  allowSelectDisabled?: boolean;
}

const PictureCollection: React.FC<PictureCollectionProps> = ({
  pictures,
  selectedPictures,
  onSelect,
  allowSelectDisabled = false,
}) => {
  const selectPicture = (picture: Picture) => {
    if (picture.isDisabled && !allowSelectDisabled) return;
    const index = selectedPictures.findIndex((p) => p.id === picture.id);
    if (index >= 0) {
      const temp = [...selectedPictures];
      temp.splice(index, 1);
      onSelect(temp);
    } else {
      onSelect([...selectedPictures, picture]);
    }
  };

  return (
    <div className="flex flex-wrap">
      {pictures.map((picture) => (
        <div key={picture.id} className="relative">
          <input
            id={picture.id.toString()}
            className={`absolute top-1 left-1 z-10 ${
              picture.isDisabled && !allowSelectDisabled
                ? "cursor-not-allowed"
                : "cursor-pointer"
            }`}
            type="radio"
            value={""}
            disabled={picture.isDisabled && !allowSelectDisabled}
            onChange={() => {}} // Controlled by onClick
            checked={
              selectedPictures.find((pic) => pic.id === picture.id) !==
              undefined
            }
            onClick={() => selectPicture(picture)}
          />
          <label
            htmlFor={picture.id.toString()}
            className={`block w-20 h-20 me-3 mb-3 relative rounded ${
              picture.isDisabled && !allowSelectDisabled
                ? "cursor-not-allowed"
                : "cursor-pointer"
            }`}
            onClick={() => selectPicture(picture)}
          >
            <div className="relative w-full h-full">
              <PictureThumbnail
                imageSrc={picture.picture}
                name={picture.picture}
              />
              {picture.isDisabled && (
                <>
                  <div className="absolute inset-0 rounded bg-gray-500 opacity-40 pointer-events-none" />
                  <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <span className="block w-[2px] h-[140%] bg-white opacity-80 transform rotate-45 rounded-full" />
                  </div>
                </>
              )}
            </div>
          </label>
        </div>
      ))}
    </div>
  );
};

export default PictureCollection;
